var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSm01X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.255101 0.253917C0.564313 -0.0538611 1.04818 -0.0818409 1.38915 0.169977L1.48683 0.253917L9 7.73182L16.5132 0.253917C16.8224 -0.0538611 17.3062 -0.0818409 17.6472 0.169977L17.7449 0.253917C18.0541 0.561695 18.0822 1.04332 17.8292 1.3827L17.7449 1.47994L9.61587 9.57124C9.30665 9.87902 8.82279 9.907 8.48182 9.65518L8.38413 9.57124L0.255101 1.47994C-0.0850335 1.14138 -0.0850335 0.592472 0.255101 0.253917Z",
    fill: "#222222",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7449 17.7461C17.4357 18.0539 16.9518 18.0818 16.6108 17.83L16.5132 17.7461L9 10.2682L1.48683 17.7461C1.17762 18.0539 0.693754 18.0818 0.352786 17.83L0.255101 17.7461C-0.0541117 17.4383 -0.0822225 16.9567 0.17077 16.6173L0.255101 16.5201L8.38413 8.42876C8.69335 8.12098 9.17721 8.093 9.51818 8.34482L9.61587 8.42876L17.7449 16.5201C18.085 16.8586 18.085 17.4075 17.7449 17.7461Z",
    fill: "#222222",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm01X);
export default __webpack_public_path__ + "static/media/SM01-X.0085ff5bd1e1d725477f8625543cbcb0.svg";
export { ForwardRef as ReactComponent };